import React, { ChangeEvent, useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'

import checkbox_active from '@/assets/common/join/active_checkbox.png'
import checkbox from '@/assets/common/join/checkbox.png'
import InquirySelect from '@/features/support/inquiry/components/InquirySelect'
import InputForm from '@/shared/components/common/CommonForm/InputForm'
import TextAreaForm from '@/shared/components/common/CommonForm/TextAreaForm'
import Loading from '@/shared/components/common/Loading'
import Modal from '@/shared/components/common/Modal/Modal'
import { TYPE_CENTERSUBMIT } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useCenterSubmitQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { useModal } from '@/shared/hooks/useModal'
import useOnInput from '@/shared/hooks/useOnInput'
import useValid from '@/shared/hooks/useValid'
import {
  InquiryContent,
  InquiryEmail,
  InquiryName,
  InquiryPhoneNum,
  InquiryTitle,
  InquiryTypeState,
} from '@/shared/store'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import { InquiryTerms, InquiryWrap } from '@/styles/views/Support/Inquiry'

const InquiryPage = () => {
  const { width } = useWindowDimensions()
  const valid = useValid()
  const onInput = useOnInput()
  const { isOpen, toggle } = useModal()
  const [termsAgree, setTermsAgree] = useState('0')
  const [InquiryNameState, setInquiryNameState] = useRecoilState(InquiryName)
  const [InquiryTelNumState, setInquiryTelNumState] = useRecoilState(InquiryPhoneNum)
  const [InquiryEmailState, setInquiryEmailState] = useRecoilState(InquiryEmail)
  const [InquiryTitleState, setInquiryTitleState] = useRecoilState(InquiryTitle)
  const [InquiryContentState, setInquiryContentState] = useRecoilState(InquiryContent)
  const [InquiryType, setInquiryTypeState] = useRecoilState(InquiryTypeState)
  const [modalOption, setModalOption] = useState({ type: '', title: '', content: '', setOption: 0 })
  const { isLoading, mutateAsync: centerSubmit } = useCenterSubmitQueryData(
    TYPE_CENTERSUBMIT,
    InquiryType,
    InquiryNameState[0].state,
    InquiryTelNumState[0].state,
    InquiryEmailState[0].state,
    InquiryTitleState[0].state,
    InquiryContentState,
    termsAgree,
  )

  const SubmitCondition =
    InquiryNameState[0].check &&
    InquiryTelNumState[0].check &&
    InquiryEmailState[0].check &&
    InquiryTitleState[0].check &&
    InquiryType !== 'none' &&
    termsAgree === '1'
  const InputDataList = [
    {
      title: '성명',
      valid: valid.InquiryNameValid,
      check: InquiryNameState[0].check,
      oninput: onInput.InquiryName,
      placeholder: '성명을 입력해주세요.',
    },
    {
      title: '연락처',
      valid: valid.InquiryPhoneNumValid,
      check: InquiryTelNumState[0].check,
      oninput: onInput.InquiryPhoneNum,
      value: InquiryTelNumState[0].state,
      placeholder: '연락처를 입력해주세요.',
    },
    {
      title: '이메일',
      valid: valid.InquiryEmailValid,
      check: InquiryEmailState[0].check,
      oninput: onInput.InquiryEmail,
      placeholder: '이메일을 입력해주세요.',
    },
    {
      title: '제목',
      valid: valid.InquiryTitleValid,
      check: InquiryTitleState[0].check,
      oninput: onInput.InquiryTitle,
      placeholder: '제목을 입력해주세요.',
    },
  ]
  const InquirySubmit = () => {
    SubmitCondition &&
      centerSubmit().then((data) => {
        if (data?.Header.ErrCode === 0) {
          setModalOption({ type: 'alert', title: '', content: '', setOption: 206 })
          toggle()
        }
      })
  }
  const TermsModalOpen = () => {
    setModalOption({
      type: 'terms',
      title: '이용약관',
      content:
        '1:1문의 이용약관 <br/><br/>' +
        '1. 수집 정보 ㈜데이터유니버스는 이용자의 원활한 고객상담 및 불만처리를 위하여 아래와 같은 정보를 수집 합니다.<br/>' +
        ' * 수집 정보 : 이름, 연락처, 이메일 주소, 고객의 문의/답변 내용에 포함된 정보 <br/><br/>' +
        '2. 수집 및 이용 목적 수집된 정보는 고객문의 및 상담요청에 대하여 회신을 하거나, 상담을 위한 서비스 이용기록 조회를 목적으로 활용합니다.<br/><br/>' +
        ' 3. 보관 및 이용 기간 이용자의 정보는 문의 처리 이후 3년간 보관 후 파기됩니다.',
      setOption: 0,
    })
    toggle()
  }

  useEffect(() => {
    setInquiryNameState([{ state: '', check: false }])
    setInquiryTelNumState([{ state: '', check: false }])
    setInquiryEmailState([{ state: '', check: false }])
    setInquiryTitleState([{ state: '', check: false }])
    setInquiryContentState('')
    setInquiryTypeState('none')
  }, [
    setInquiryContentState,
    setInquiryEmailState,
    setInquiryNameState,
    setInquiryTelNumState,
    setInquiryTitleState,
    setInquiryTypeState,
  ])

  return (
    <InquiryWrap>
      {isLoading && <Loading />}
      <InquirySelect title="문의유형" />
      {InputDataList?.map(
        (element: {
          title: string
          value?: any
          valid: any
          check: boolean
          placeholder: string
          oninput: (e: ChangeEvent<HTMLInputElement>) => void
        }) => (
          <InputForm
            title={element.title}
            value={element.value}
            valid={element.valid}
            check={element.check}
            oninput={element.oninput}
            placeholder={element.placeholder}
            key={element.title}
          />
        ),
      )}
      <TextAreaForm title="문의내용" />
      <InquiryTerms>
        <img
          src={termsAgree === '1' ? checkbox_active : checkbox}
          alt="부분약관"
          onClick={() => setTermsAgree(termsAgree === '0' ? '1' : '0')}
        />
        <p>
          개인정보 수집 및 이용에 동의합니다. (문의 응대 외의 용도로는 사용되지 않습니다.)
          {width > 1200 ? (
            <span onClick={TermsModalOpen}>보기</span>
          ) : (
            <span onClick={TermsModalOpen}>보기</span>
          )}
        </p>
      </InquiryTerms>
      <CustomBtn
        color={COLOR.white}
        bgColor={SubmitCondition ? COLOR.point1 : COLOR.gray30}
        borderRadius={'40px'}
        marginTop={width > 1200 ? '64px' : '56px'}
        width={width > 1200 ? '356px' : '328px'}
        height={width > 1200 ? '56px' : '44px'}
        fontSize={width > 1200 ? '18px' : '14px'}
        fontFamily={width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'}
        onClick={InquirySubmit}
      >
        <span>문의하기</span>
      </CustomBtn>
      <Modal
        isOpen={isOpen}
        type={modalOption.type}
        option={modalOption}
        setOption={modalOption.setOption}
        ClickFunc={modalOption.setOption === 206 ? () => window.location.reload() : toggle}
      />
    </InquiryWrap>
  )
}
export default InquiryPage
